module.exports = __webpack_public_path__ + "img/fd.936456d8.jpg";